import script from "./NewGame.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewGame.vue?vue&type=script&lang=ts&setup=true"

import "./NewGame.vue?vue&type=style&index=0&id=7625812e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7625812e"]])

export default __exports__